module.exports = __webpack_public_path__ + "mer/fonts/iconfont.665b5cf9.ttf";